import store from 'store2';
import config from 'config';
import { createReducer } from '../helpers';
import { ui, api } from '../actions';

const initialState = {
    mobileMenuVisible: false,
    pagePreview: null,
    isClientExpired: false,
    conversationsFilter: {
        status: 'open',
        assign: 'all',
        searchValue: '',
        showNewFirst: true,
        ...(store.get('conversationsFilter') || {}),
    },
    unsubscribe: {
        status: 'initial',
    },
    isAdvancedStylingMode: store.get('advancedStylingMode') || false,
    isMobileContainer: false,
    backTrack: '',
    appTrackingStatus: null,
};

export default createReducer(initialState, {
    [ui.toggleMobileMenu]: (state, action) => {
        state.mobileMenuVisible = action.payload;
    },
    [ui.toggleStylingMode]: (state) => {
        state.isAdvancedStylingMode = !state.isAdvancedStylingMode;
    },
    [ui.toggleMobileContainer]: (state, action) => {
        state.isMobileContainer = typeof action.payload === 'boolean' ? action.payload : !state.isMobileContainer;
    },
    [ui.setMessage]: (state, action) => {
        state.message = action.payload;
    },
    [ui.setConversationsFilter]: (state, action) => {
        state.conversationsFilter = {
            ...state.conversationsFilter,
            ...action.payload,
        };
    },
    [ui.setPagePreview]: (state, action) => {
        state.pagePreview = action.payload;
    },
    [ui.setPageBlockPreview]: (state, action) => {
        if (action.payload._id) {
            state.pagePreview.blocks = state.pagePreview.blocks.map((block) => {
                if (block._id === action.payload._id) {
                    return action.payload;
                }

                return block;
            });
        } else {
            const hasBlocks = state.pagePreview.blocks.length > 0;
            const hasNewBlock = hasBlocks && !state.pagePreview.blocks.slice(-1).pop()._id;

            if (hasNewBlock) {
                state.pagePreview.blocks = state.pagePreview.blocks.map((block) => {
                    if (!block._id) {
                        return action.payload;
                    }

                    return block;
                });
            } else {
                state.pagePreview.blocks.push(action.payload);
            }
        }
    },
    [api.listenVerifyVersion]: (state, action) => { // TODO: remove
        state.isClientExpired = action.payload !== config.version;
    },
    [api.unsubscribe]: (state, action) => {
        state.unsubscribe.status = 'pending';
    },
    [api.listenSubscriptionCancelled]: (state, action) => {
        state.unsubscribe.state = 'finish';
    },
    [ui.setBackTrack]: (state, action) => {
        state.backTrack = action.payload;
    },
    [ui.setAppTrackingStatus]: (state, action) => {
        state.appTrackingStatus = action.payload;
    },
});
